"use strict";

exports.__esModule = true;
exports["default"] = isExperimentEnabled;

var _lodash = require("lodash");

function isExperimentEnabled(experiments, experiment, value) {
  if (value === void 0) {
    value = 'true';
  }

  var values = Array.isArray(value) ? value : [value];
  return values.includes((0, _lodash.get)(experiments, experiment));
}